import React, { useState, useEffect, useContext } from 'react';
import './bls-view-details.scss';
import { default as t } from '../../../utils/i18n';
import queryString from 'query-string';
import { UserContext, ToasterContext } from '../../../context';
import { Table } from 'rsuite';
import { Button } from '../../atoms';
import { BlsService } from '../../../services';
import { navigateUrl } from '../../../utils/malaRedirect';

const ViewBlsData = props => {
  const location = queryString?.parse(window.location.search);
  const studyId = location?.accountId;
  const { user, setUser } = useContext(UserContext);
  const { message, setMessage } = useContext(ToasterContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const { Column, HeaderCell, Cell } = Table;
  const [studyDetails, setStudyDetails] = useState('');

  const handleBackClick = e => {
    props.handleBackClick(e);
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };

  useEffect(() => {
    setMessage({});
    getStudyDetailsThroughId();
  }, []);

  async function getStudyDetailsThroughId() {
    try {
      const bmResponse = await BlsService.getStudyDetails(userAccessToken, username, studyId);
      let types = bmResponse.data?.data;
      types.cells[0].selected = true;
      setStudyDetails({ ...types });
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const getDisplayDate = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '/' + mm + '/' + yyyy;
  };

  const onClickOfCells = cIndex => {
    studyDetails.cells?.forEach(cell => (cell.selected = false));
    studyDetails.cells[cIndex]['selected'] = true;
    setStudyDetails({ ...studyDetails });
  };

  const SelectedCampaignsContainer = ({ cell }) => {
    return (
      <div className="campaigns-list-container">
        <div className="list-scroll-container selected-container">
          <div className="list-scroll">
            {cell?.campaigns?.length && (
              <div className="selected_campaign_header">
                {t('bls.study.selected.campaigns')}({cell?.campaigns?.length})
              </div>
            )}
            <div className="selected-list">
              {cell?.campaigns?.map(item => {
                return (
                  <div className="selected-item" key={item.name}>
                    <span className="selected-value" title={item?.name}>
                      {item?.name}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const CellDetails = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props}>
        <div className="text_overflow" title={rowData[dataKey]}>
          {rowData[dataKey]}
        </div>
      </Cell>
    );
  };

  return (
    <section>
      <div className="view_bls_container">
        <div className="business_account_details">
          <div className="view_details">
            <div className="heading-btn-container">
              <div className="header-holder">
                <button className="return-insights" onClick={() => handleBackClick()}>
                  <i className="eva  eva-arrow-ios-back-outline"></i>
                  {t('bls.back')}
                </button>
              </div>
              {user?.isMalaRedirect ? (
                <div className="mala-redirect-button">
                  <Button
                    type="button"
                    label={t('Back to Manage Learning Agenda')}
                    handleClick={() => {
                      navigateUrl(user);
                    }}
                  ></Button>
                </div>
              ) : null}
            </div>
            <div className="import-campaign-cta add_bls">
              <div className="accounts_header">
                {t('bls.study.for')}: &nbsp;{user?.dropdowns?.adaccount?.label}
              </div>
            </div>
            <div className="account_details_container">
              <div className="ad_ac_details">
                <div>
                  <div className="study-name">{studyDetails?.studyName}</div>
                  <div className="ac_details_val">{user?.dropdowns?.businessManager?.label}</div>
                </div>
              </div>
              <div className="btn_submit">
                <div>
                  <div className="ac_details_header">{t('bls.study.ad.account')}</div>
                  <div className="study-id">{studyDetails?.adAccountId}</div>
                </div>
                <div>
                  <div className="ac_details_header">{t('bls.date.range')}</div>
                  <div className="study-id">
                    {studyDetails?.startDate && studyDetails?.endDate ? (
                      <>
                        {getDisplayDate(new Date(studyDetails?.startDate))} -{' '}
                        {getDisplayDate(new Date(studyDetails?.endDate))}
                      </>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="cells_container">
              <div className="cells_group_choose">
                <div className="btn_submit">
                  {studyDetails?.cells?.map((cell, cellIndex) => {
                    return (
                      <div>
                        <button
                          className={cell?.selected ? 'step-back step-add' : 'step-back'}
                          onClick={() => onClickOfCells(cellIndex)}
                        >
                          {cell?.name}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
              {studyDetails?.cells?.map((cell, cellIndex) => {
                if (cell?.selected) {
                  return (
                    <div className="individual_cell">
                      <div className="cell_name_header">{cell?.name}</div>
                      <div>
                        {cell?.campaigns?.length ? (
                          <SelectedCampaignsContainer cell={cell} cIndex={cellIndex} />
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="question_header">{t('bls.questions')}</div>
                      <div className="question_table_container">
                        <div tabindex="0" id="table" className="table-container">
                          <Table
                            height={400}
                            data={cell?.experiments}
                            bordered
                            locale={{ emptyMessage: t('define.stepper.table.noDataFound') }}
                            onRowClick={rowData => {
                              rowData.isSelected = true;
                            }}
                          >
                            <Column width={getWidth(10)}>
                              <HeaderCell>{t('bls.exp.id')}</HeaderCell>
                              <CellDetails dataKey="id" />
                            </Column>
                            <Column width={getWidth(4)} align="left" fixed>
                              <HeaderCell>{t('bls.choose.qtype')}</HeaderCell>
                              <CellDetails dataKey="questionType" />
                            </Column>

                            <Column width={getWidth(5)} align="left" fixed>
                              <HeaderCell>{t('blis.brand.study')} </HeaderCell>
                              <CellDetails dataKey="advancedLift" />
                            </Column>

                            <Column width={getWidth(6)} flexGrow={1} fixed>
                              <HeaderCell>{t('bls.cost.per.lift')}</HeaderCell>

                              <CellDetails dataKey="costPerIncrementalBreakthrough" />
                            </Column>
                            <Column width={getWidth(6)} flexGrow={1} fixed>
                              <HeaderCell>{t('bls.volume')}</HeaderCell>

                              <CellDetails dataKey="incrementalAdrecaller" />
                            </Column>
                          </Table>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ViewBlsData;
